import {createApi} from '@reduxjs/toolkit/query/react';
import {baseQuery} from '@store/baseQuery';

export type ContactType = 'telegram' | 'email' | 'max' | 'phone';

export interface SupportContactRequest {
    name: string;
    contact_type: ContactType;
    contact: string;
    message: string;
    order_id?: string | null;
}

export interface SupportContactResponse {
    message: string;
}

export const PayApi = createApi({
    reducerPath: 'payApi',
    baseQuery: baseQuery(),
    endpoints: (build) => ({
        sendSupportContact: build.mutation<SupportContactResponse, SupportContactRequest>({
            query: (body) => ({
                url: '/tariffs/support',
                method: 'POST',
                body,
            }),
        }),
    }),
});

export const {useSendSupportContactMutation} = PayApi;
